import React from 'react';
import GenericPageContainer from 'src/components/EntityPage/GenericPageContainer';
import { BEACON_SUBTABS } from 'src/components/BeaconV2Components/GenericSidebarNav/useBeaconRoutes';
import ContentGenerationProfile from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Generate';
import ContentGenMultiReview from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/ContentGenSingleReview';
import LibraryReview from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/LibraryReview';
import { ProfileSummary } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Profile/ProfileSummary';
import ProfileSettings from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Profile/ProfileSettings';
import { LibrarySummary } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Settings/Library';
import ProjectTable from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Project/ProjectTable';
import { ProjectSettings } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Project/ProjectSettings';
import { ProjectReview } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Project/ProjectReview';
import { ProjectProducts } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentGeneration/Project/ProjectProducts';

const getGenerationPageLayout = ({ metricType }) => {
  switch (metricType) {
    case BEACON_SUBTABS.GENERATE:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.GENERATE,
            CustomComponent: () => <ContentGenerationProfile />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.GENERATION_REVIEW:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.GENERATION_REVIEW,
            CustomComponent: ContentGenMultiReview,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROFILES_ACTIVE:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROFILES_ACTIVE,
            CustomComponent: () => <ProfileSummary selectedId="ACTIVE" />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROFILES_PROFILE:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROFILES_PROFILE,
            CustomComponent: () => <ProfileSummary />, // legacy behavior
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROFILES_ARCHIVED:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROFILES_ARCHIVED,
            CustomComponent: () => <ProfileSummary selectedId="ARCHIVED" />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.LIBRARY:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.LIBRARY,
            CustomComponent: () => <LibrarySummary />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROFILES_SETTINGS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROFILES_SETTINGS,
            CustomComponent: () => <ProfileSettings />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.SYNDICATION:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.SYNDICATION,
            CustomComponent: () => <div>Syndication Component</div>, // Replace with SyndicationComponent
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROJECTS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROJECTS,
            CustomComponent: () => <ProjectTable />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROJECTS_SETTINGS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROJECTS_SETTINGS,
            CustomComponent: () => <ProjectSettings />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROJECTS_PRODUCTS:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROJECTS_PRODUCTS,
            CustomComponent: () => <ProjectProducts />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.PROJECTS_REVIEW:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.PROJECTS_REVIEW,
            CustomComponent: () => <ProjectReview />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };
    case BEACON_SUBTABS.LIBRARY_REVIEW:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.LIBRARY_REVIEW,
            CustomComponent: LibraryReview,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.EXISTING_SETTING:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.EXISTING_SETTING,
            CustomComponent: () => <ProjectSettings isExisting={true} />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    case BEACON_SUBTABS.EXISTING_REVIEW:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.EXISTING_REVIEW,
            CustomComponent: () => <ProjectReview isExisting={true} />,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };

    default:
      return {
        CustomPageContainer: GenericPageContainer,
        enableComparison: false,
        widgets: [
          {
            name: BEACON_SUBTABS.GENERATE,
            CustomComponent: () => <div>Default Generate Component</div>,
            view: {}
          }
        ],
        containerStyle: {},
        dataConfig: {}
      };
  }
};

export default getGenerationPageLayout;
